import { Equal, IQueryCommandOptions, Not } from '@llws/dynamic-router-utils';
import { IWaitinglists } from '@llws/lift-entity-interfaces';
import { StoreBaseImplementationV2 } from '@/shared/classes/store-base-implementation-v2';

// Base store configuration
const adminGatewayResourcePath: string = '/website-api/waitinglists';
const listViewName: string = '';
const showLogging: boolean = false;

const defaultGetListFilters: IQueryCommandOptions = {
  relations: [
    {
      path: 'city',
      alias: 'city',
    },
    {
      path: 'building',
      alias: 'building',
    },
    {
      path: 'building.city',
      alias: 'buildingCity',
    },
    {
      path: 'site',
      alias: 'site',
    },
    {
      path: 'waitingListSuiteType',
      alias: 'suiteType',
    },
  ],
  where: [
    Not(Equal('status', 'deleted')),
  ],
};
const defaultGetSingleFilters: IQueryCommandOptions = {
  relations: [
    {
      path: 'city',
      alias: 'city',
    },
    {
      path: 'building',
      alias: 'building',
    },
  ],
};

// Instantiate the base store with the params
const base = new StoreBaseImplementationV2<IWaitinglists>({
  adminGatewayResourcePath,
  defaultGetSingleFilters,
  defaultGetListFilters,
  listViewName,
  showLogging,
});

// Extend StoreBaseImplementation object to add custom state/getters/mutations/actions.
export default {
  namespaced: base.namespaced, // 'waiting-lists/'

  state: {
    ...base.state,
  },

  getters: {
    ...base.getters,
  },

  mutations: {
    ...base.mutations,
  },

  actions: {
    ...base.actions,
  },
};
